export const filterKarts = (karts, statFilters) => {
  return karts.filter((k) => kartPassesStatFilters(k, statFilters));
};

const kartPassesStatFilters = (kart, filters) => {
  // When game data changes, uncomment these lines (and adjust the values as needed)
  // to find the Handicap Quick Pick.
  // return kart.stats[0] < 3
  //     && kart.stats[1] < 3
  //     && kart.stats[2] < 3
  //     && kart.stats[3] < 3
  //     && kart.stats[4] < 3

  const kartFails = filters.some((f) => !kartPassesStatFilter(kart, f));
  return !kartFails;
};

const kartPassesStatFilter = (kart, filter) => {
  return kart.stats[filter.stat.index] >= filter.score;
};
